import React, { useContext } from 'react'
import { CompensationResponse } from '../../../../api/salaryCalculation'

type PayoutPopupContextProps = {
  data?: CompensationResponse
  isTotalBonusBiggerThanGuaranteed: boolean
  updatePopoverPosition: () => void
}

export const PayoutPopupContext = React.createContext<PayoutPopupContextProps>({
  data: undefined,
  isTotalBonusBiggerThanGuaranteed: false,
  updatePopoverPosition: () => {
    console.log('Pass properly updatePopoverMethod to your context provider')
  },
})

export const usePayoutPopupContext = () => useContext(PayoutPopupContext)
